import React from "react";
import Header from "../modules/header";

import "react-day-picker/lib/style.css";
import { Link } from "react-router-dom";
import btnarw from '../assets/images/icons/button-arrow.png';
import vector22 from '../assets/images/icons/vector2.png';

class NoMatch extends React.Component {
  constructor(props) {
    super(props);
    
  }

  render() {
    return (
      <div className="open_menudiv">
        <Header></Header>
        <section id="date-quote-section" className="section fix date-quote-section" >
          <div className="container">
            <div className="row">
              <div className="col-lg-6 col-md-6">
                <div className="row">
                  <div className="date_startdiv">
                    <div className="date-from-to">
                    </div>
                  </div>
                  <div className="date_enddiv">
                    <div className="price-from-div">
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col" id="mobile_butndate">
                <div className="row Date_buttons">
                  <div className="date_back-btn">
                    <div className="back-btn">
                      
                    </div>
                  </div>
                  <div className="date_quote_btn">
                    <div className="get-quote-btn">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="calendar" className="section fix calendar-box">
          <div className="container">
            <div className="row">
              <div className="col-lg-3"></div>
              <div className="col-lg-6">
                <div className="calendar1">
                  <div className="load-moregems">
                    <div className="gems-content">
                        <p className="title">404 - Page Not Found</p>
                        <p className="txt">The page you are looking is not available</p>
                        <Link to="/">
                        <button className="btn btn-secondary btn-theme">
                            <span>Back to Home</span>
                            <img src={btnarw} className="img-responsive" alt="button arrow" />
                        </button>
                        </Link>
                    </div>
                    <div className="vector-img">
                        <img id="last_destinatio_vector" src={vector22} className="img-responsive" alt="vector" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3"></div>
              
            </div>
          </div>
        </section>
      </div>
    );
  }
}
export default NoMatch;
